// Package dependencies
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { isEmpty } from 'lodash';
import appConfig from '@nerdwallet/app-config';

// Local Dependencies
import { getLogger } from '@nerdwallet/logging';
import { fetch } from './fetch';

const logger = getLogger('actions');

export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const PENDING_SEARCH_RESULTS = 'PENDING_SEARCH_RESULTS';
export const RECEIVE_SEARCH_PRODUCTS = 'RECEIVE_SEARCH_PRODUCTS';
export const PENDING_PRODUCT_RESULTS = 'PENDING_PRODUCT_RESULTS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const FETCH_ERROR = 'FETCH_ERROR';

// Action creators

export const requestError =
  (error, url = '(url not provided)') =>
  (dispatch) => {
    logger.error(`failed to fetch ${url}: `, error);
    dispatch({
      type: REQUEST_ERROR,
      error: {
        url,
        error,
      },
    });
  };

export const submitRequest =
  ({ callback, query, successAction, pendingAction, errorAction, apiURL }) =>
  (dispatch) =>
    new Promise((resolve, reject) => {
      const fetchCallbackErr = (error) => {
        dispatch({
          type: errorAction,
        });
        dispatch(requestError(error, apiURL));

        if (callback) {
          callback();
        }

        return reject(error);
      };
      const fetchCallback = (data) => {
        dispatch({
          type: pendingAction,
          pending: false,
        });
        dispatch({
          type: successAction,
          data,
          query,
          error: false,
        });
        return resolve();
      };
      dispatch({
        type: pendingAction,
        pending: true,
      });
      fetch(
        `${apiURL}`,
        undefined,
        query,
        'GET',
        (response) => {
          fetchCallback(response.data);

          if (callback) {
            callback();
          }
        },
        fetchCallbackErr,
        ''
      );
    });

export const submitSearch = ({
  callback,
  resultsPerPage = 10,
  searchTerm,
  page,
  facets,
}) => {
  const query = {
    query: searchTerm || '',
    query_fields: [
      'content_sanitized',
      'content_type^8',
      'link^10',
      'tag_names',
      'title_sanitized^10',
    ].join(','),
    source_fields: [
      'content_type',
      'category_names',
      'link',
      'title_rendered',
    ].join(','),
    limit: resultsPerPage,
    offset: (page || 0) * resultsPerPage,
    include_facets: true,
    include_highlights: true,
  };

  let facetsObj = facets;
  if (typeof facets === 'string') {
    try {
      facetsObj = JSON.parse(facets);
    } catch (e) {
      facetsObj = {};
    }
  }

  const getFacetGroup = (key) =>
    (facetsObj[key] || []).map((value) => `"${value}"`).join(',');
  const serializedCats = getFacetGroup('category');
  const serializedContent = getFacetGroup('content_type');
  if (!isEmpty(serializedCats)) {
    query.categories = serializedCats;
  }
  if (!isEmpty(serializedContent)) {
    query.content_types = serializedContent;
  }

  return submitRequest({
    callback,
    query,
    successAction: RECEIVE_SEARCH_RESULTS,
    pendingAction: PENDING_SEARCH_RESULTS,
    errorAction: FETCH_ERROR,
    apiURL: `${appConfig.API.BASE_URLS.NW_SEARCH_SERVICE}/v2/content`,
  });
};

export const submitProductSearch = ({ callback, searchTerm = '' }) => {
  const queryFields = [
    'offer.product.institution.name^1.25',
    'offer.details.processing_network',
    'offer.details.seo_name',
    'offer.details.slug',
    'offer.product.name',
  ].join(',');
  const query = {
    query: searchTerm,
    query_fields: queryFields,
    sort: 'offer.details.popularity_rank',
    named_query: 'nw_search_cc_offers',
    limit: 18,
  };

  return submitRequest({
    callback,
    query,
    successAction: RECEIVE_SEARCH_PRODUCTS,
    pendingAction: PENDING_PRODUCT_RESULTS,
    errorAction: FETCH_ERROR,
    apiURL: `${appConfig.API.BASE_URLS.MARKETPLACE}/offers/v1/credit_cards/full_text_search`,
  });
};
